import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import { CheckCouponResponse } from "./data";
import { apiCheckCoupon } from "./service";

export const useCheckCoupon = (params: any, options: any) => {
  return useQuery<CheckCouponResponse>({
    queryKey: [queryKey.COUPON_CHECK],
    queryFn: () =>
      apiCheckCoupon(params).then(
        (res: ApiResponse<CheckCouponResponse>) => res.data.data
      ),
    ...options,
  });
};
